(() => {
  const init = (root) => {
    if (!root || root.dataset.sblp2Ready === 'true') return;
    root.dataset.sblp2Ready = 'true';

    root.querySelectorAll('[data-sblp2-tabs]').forEach((tabs) => {
      const buttons = Array.from(tabs.querySelectorAll('[data-sblp2-tab]'));
      const panels = Array.from(tabs.querySelectorAll('[data-sblp2-panel]'));

      const activate = (id, focus = false) => {
        buttons.forEach((button) => {
          const active = button.dataset.sblp2Tab === id;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          if (active && focus) button.focus({ preventScroll: true });
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.sblp2Panel !== id;
        });
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button.dataset.sblp2Tab));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          activate(buttons[next].dataset.sblp2Tab, true);
        });
      });

      if (buttons[0]) activate(buttons[0].dataset.sblp2Tab);
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-sblp2-root]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    const panel = block.closest('[data-sblp2-panel]');
    const root = block.closest('[data-sblp2-root]');
    if (!panel || !root) return;
    const button = root.querySelector(`[data-sblp2-tab="${panel.dataset.sblp2Panel}"]`);
    if (button) button.click();
  });
})();
